import type { MouseEvent } from 'react'
import { dispatchSubsNavigation } from '@/msgdeskRuntime/subsNavigation'

// Legacy refresh button — self-contained (markup + wiring + Tailwind).
// Pick a look by importing from this folder or ../Modern.

export function RefreshSubs({ section }: { section: 0 | 1 }) {
  function handleRefresh(event: MouseEvent<HTMLElement>) {
    dispatchSubsNavigation({ action: 'refresh', section, target: event.currentTarget })
  }

  return (
    <span
      className="md-hook-no-select md-refresh-subs mr-[7px] flex h-4 w-4 flex-[0_0_16px] cursor-pointer select-none items-center justify-center text-[14px] font-bold leading-none text-[#3472a9]"
      data-md-legacy-class="mcss-no_select-cssm"
      onClick={handleRefresh}
    >
      ↻
    </span>
  )
}
